import { Injectable } from '@angular/core';
import { Nav } from 'ionic-angular';
import { LoginWebPage } from '../../pages/login-web/login-web';
import { BehaviorSubject } from 'rxjs';

interface Conteudo {
  pagina: any,
  params: any
}

@Injectable()
export class NavProxyProvider {

  private _navMenu: Nav;
  private _navContent: Nav;
  private _navMain: Nav;
  private _$conteudo: BehaviorSubject<Conteudo>;

  constructor() {
    this._$conteudo = new BehaviorSubject(null);
  }

  public get conteudo() {
    return this._$conteudo.asObservable();
  }

  public setNavMenu(nav: Nav) {
    this._navMenu = nav;
  }

  public setNavContent(nav: Nav) {
    this._navContent = nav;
  }

  public setNavMain(nav: Nav) {
    this._navMain = nav;
  }

  public pushContent(page: any, params?: any): void {
    this._navContent.setRoot(page, params);
    this._$conteudo.next({
      pagina: page,
      params: params
    });
  }

  public pushMainPageLogin(): void {
    this._navMain.setRoot(LoginWebPage);
  }

}



// WEBPACK FOOTER //
// ./src/providers/nav-proxy/nav-proxy.ts